import { useRef, useState, useEffect } from "react";

/**
 * useContainerWidth
 * Returns a ref and boolean indicating if container width is below breakpoint.
 * Usage:
 *   const [ref, isMobile] = useContainerWidth();
 *   <div ref={ref}>...</div>
 */
export default function useContainerWidth(breakpoint = 768) {
  const containerRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (!containerRef.current) return;

    const update = (width) => setIsMobile(width < breakpoint);

    // Initial measurement
    update(containerRef.current.getBoundingClientRect().width);

    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        update(entry.contentRect.width);
      }
    });

    observer.observe(containerRef.current);

    return () => observer.disconnect();
  }, [breakpoint]);

  return [containerRef, isMobile];
}
